// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"cfb2bd51","121":"e1a7dee2","157":"d0c6830f","217":"55bfcde6","466":"6cb4c7b6","518":"7a600160","549":"58341462","648":"4af9d25d","669":"64d3dacf","703":"eaf86f61","787":"7450c77a","853":"57e22e4e","969":"9189eb59"}[chunkId] + ".chunk.js";
};